module.exports = __webpack_public_path__ + "img/equipa_suporte.fc80c233.jpg";